import React from 'react';
import styles from './index.less';
import ToolbarItemColor from '../tool-bar/toolbar-item-color';
import { DropdownType } from '../../../editor/src/js/constants/toolbar-data';
import ToolbarItemText from '../tool-bar/toolbar-item-text';
import ToolbarItemImage from '../tool-bar/toolbar-item-image';
import { ActionType } from '../../../editor/src/js/constants/common-action-type';
import Divider from '@tencent/dui/lib/components/Divider';
import { StyleMode } from '../../../editor/src/js/constants/float-toobbar-data';
import { IReactionDisposer, reaction } from 'mobx/lib/mobx';
import ItemIcon from '../float-toolbar/float-item-icon';
import Snackbar from '@tencent/dui/lib/components/Snackbar/index';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType, TDWVer9Type } from '../../../../slide/infrastructure/module/dependent/report/offline-data-report/constant';
import i18n from '@i18next/i18n';
import { getQuickSetFontSize } from './quick-setting-fontsize';
import { FontSizeBoundaryVal } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/font-size';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import AttachmentUploader from '@src/js/common/ark-extensions/dc-components/attachment-uploader';
import classNames from 'classnames';
import _debounce from 'lodash/debounce';
import { ADDON_PREFIX } from '@src/slide/domain/ui-model/element-modeles/property/addon/addon.interface';
import { MenuType } from '../../../../slide/domain/ui-model/constant/menu';
import { PPTEditorStateType } from '../../../../slide/domain/ui-model/constant/edit-state-type';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { transaction } from '@src/slide/domain/slide-app';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { ImageReplaceAction } from '@src/slide/application/service/copy-paste/core/cp-image.new/image-edit-manager/core/image-edit-manager.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { IMenuItems } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IUserPriviledgeService } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import { IAddonHandler } from '@src/slide/application/service/addon/addon-handler.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { SelectedModelType } from '@src/slide/application/service/selection/selection-service.interface';

interface QuickSettingProps {
    noShadow?: boolean;
    userPriviledgeService: IUserPriviledgeService;
}

interface QuickSettingState {
    data: IMenuItems | undefined;
}

/**
 * 对象快捷设置
 */
export default class QuickSetting extends React.Component<QuickSettingProps, QuickSettingState> {
    public static keyIndex = 0;
    // 加入防抖，避免重复计算。同时通过延迟来确保disableItemIds已更新成最新状态
    private dataChange = _debounce(() => {
        const data = this.getMenuManager()?.quickSetMenu();
        const disableItems = this.getMenuManager()?.disableItemIds();
        const values = data?.values;
        this.updateValues(data?.items, values, disableItems);
        this.setState({ data });
    });
    private quickAutorun: IReactionDisposer;
    private selectionReaction: IReactionDisposer;
    private clearReaction: IReactionDisposer;
    private selectedModel: SelectedModelType;
    private snackbarOp?: ReturnType<typeof Snackbar.show>|null;
    public constructor(props, context) {
        super(props, context);

        this.state = {
            data: this.getQuickSettingData(),
        };
        QuickSetting.keyIndex += 1;
    }

    public async componentDidMount() {
        const module = await this.getCopyPasteImageService()?.promise();

        this.quickAutorun = reaction(
            () => this.getSelectionService()?.getSelectedModel(),
            (selectedModel) => {
                if (this.selectedModel?.changeSetEngine) {
                    this.selectedModel.changeSetEngine.removeChangesetObserver(this.dataChange);
                }
                this.selectedModel = selectedModel;
                if (this.selectedModel?.changeSetEngine) {
                    this.selectedModel.changeSetEngine.addChangesetObserver(this.dataChange);
                }
                if (module) {
                    module.ImageEditManager.getInstance().clipDataWaiting = false;
                }
            },
            { fireImmediately: true },
        );
        this.selectionReaction = reaction(
            () => ({
                selectedRange: (this.getSelectionService()?.getSelectedModel() as ITableModel)?.selectedRange,
                selectionStyles: (this.getSelectionService()?.getSelectedModel() as IShapeModel)?.selectionStyles,
                // 组合的快捷菜单设置边框
                quickSetMenu: (this.getSelectionService()?.getSelectedModel() as IShapeModel)
                    ?.getBorder?.().getBorderInfo(),
            }),
            () => {
                this.dataChange();
            },
        );

        this.clearReaction = reaction(
            () => module?.ImageEditManager.getInstance().clipDataWaiting,
            (waiting) => {
                this.handleImageReplace(waiting);
            },
        );
    }

    public componentWillUnmount() {
        if (this.quickAutorun) {
            this.quickAutorun();
        }
        if (this.selectionReaction) {
            this.selectionReaction();
        }
        if (this.clearReaction) {
            this.clearReaction();
        }
        if (this.selectedModel?.changeSetEngine) {
            this.selectedModel.changeSetEngine.removeChangesetObserver(this.dataChange);
        }
        // this.imageFillChangeReaction?.();
    }

    public render() {
        const { data } = this.state;
        if (!data?.items) {
            return null;
        }

        const { noShadow } = this.props;

        const items = Array.isArray(data.items) && data.items.map((item, i) => {
            let RenderComponent: any = null;
            if (item.dropdown) {
                RenderComponent = this.renderDropdownItem(item, RenderComponent);
            } else if (item.icon && item.icon.length > 0) {
                RenderComponent = ToolbarItemImage;
            } else if (item.title) {
                RenderComponent = ItemIcon;
            } else {
                RenderComponent = ToolbarItemText;
            }

            if (item.id === ActionType.DIVIDER) {
                return (
                    <Divider key={i} orientation="vertical"
                        style={{ verticalAlign: 'middle', backgroundColor: 'rgba(0, 0, 0, 0.08)', margin: '0 4px' }}/>
                );
            }
            return (
                <RenderComponent
                    key={`toolbarItem_${item.id}`}
                    {...item}
                    handleClick={this.handleClick}
                    handleDoubleClick={this.handleDoubleClick}
                    model = {StyleMode.QUICK_SETTING}
                    keyIndex={QuickSetting.keyIndex}
                    onItemClickCallBack = {this.handleMultiItemClick}
                    rightSideBarManager={this.getRightSideBarManager()}
                />
            );
        });
        const itemClass = classNames({
            [styles.quickBar]: true,
            [styles['quickBar-shadow']]: !noShadow,
        });

        if (!items || items.length === 0) return null;

        return (
            <div className={itemClass} onMouseDown={this.handleMouseDown}>{items}</div>
        );
    }

    private async handleImageReplace(waiting) {
        const module = await this.getCopyPasteImageService()?.promise();
        if (!module) return;
        const { ImageEditManager } = module;
        if (ImageEditManager.getInstance().imageReplaceAction === 2) return; // 表示是填充图片
        if (waiting) {
            this.snackbarOp = Snackbar.show({
                message: browser.isMac ? i18n.t('请使用 Cmd+V 替换该图片') : i18n.t('请使用 Ctrl+V 替换该图片'),
                duration: 3000,
            });
        } else if (this.snackbarOp) {
            this.snackbarOp.close();
            this.snackbarOp = null;
        }
    }

    private getMenuManager() {
        return this.getAppServices().editableServiceLayer?.menuManager;
    }

    private getSelectionService() {
        return this.getAppServices().viewableServiceLayer?.selectionService;
    }

    private getAddonManager() {
        return this.getAppServices().viewableServiceLayer.addonManager;
    }

    private getRightSideBarManager() {
        return this.getAppServices().editableServiceLayer?.rightSideBarManager;
    }

    private getCopyPasteImageService() {
        return this.getAppServices().editableServiceLayer?.copyPasteImageService;
    }

    private getFormatBrushManager() {
        return this.getAppServices().editableServiceLayer?.formatBrushManager;
    }

    private getSmartReplaceImageService() {
        return this.getAppServices().editableServiceLayer?.smartReplaceImageService;
    }

    private getAppServices() {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }

    private updateValues = (itemList, values, disableItems) => {
        const disableIDs = {};
        disableItems?.forEach((item) => {
            disableIDs[item.id] = true;
        });

        itemList?.forEach((item) => {
            const value = this.getItemValueForUpdataValues(values, item);
            if (typeof (value) !== 'undefined') {
                item.value = value;
            }

            if (disableIDs[item.id] && !item.enable) {
                // 通过显式设置Item的enable=true，可以覆盖固定的diable列表。
                item.disabled = true;
            } else {
                item.disabled = false;
            }

            if (item.id === ActionType.FONTSIZE_UP) {
                const fontSize = this.getCurFontSize(values);
                if (fontSize && fontSize === 192) {
                    item.disabled = true;
                } else {
                    item.disabled = false;
                }
            } else if (item.id === ActionType.FONTSIZE_DOWN) {
                const fontSize = this.getCurFontSize(values);
                if (fontSize && fontSize === 8) {
                    item.disabled = true;
                } else {
                    item.disabled = false;
                }
            }
        });
    };

    private getItemValueForUpdataValues(values, item) {
        return values?.[item.id];
    }

    private getQuickSettingData() {
        const data = this.getMenuManager()?.quickSetMenu();
        const disableItems =  this.getMenuManager()?.disableItemIds();
        const values = data?.values;

        this.updateValues(data?.items, values, disableItems);

        return data;
    }

    private handleClick = (id, value, option) => {
        if (this.props.userPriviledgeService.pptEditorState !== PPTEditorStateType.EDITABLE) {
            return;
        }
        const callback = this.state.data?.callback;
        const handleClickMap = {
            [ActionType.FORMAT_BRUSH]: () => {
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_FORMAT,
                    action: TDWActionType.FONT_FORMAT_BRUSH,
                });
                this.getFormatBrushManager()?.onClickButton();
            },
            [ActionType.FONTSIZE]: () => {
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_FORMAT,
                    action: TDWActionType.FONT_FONT_SIZE,
                });
                callback?.(MenuType.QUICK_SETTING, id, value, option);
            },
            [ActionType.BOLD]: () => {
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_FORMAT,
                    action: TDWActionType.FONT_FONT_BOLD,
                });
                callback?.(MenuType.QUICK_SETTING, id, value, option);
            },
            [ActionType.MOVE_ITEM]: () => {
                callback?.(MenuType.QUICK_SETTING, value, value);
            },
            [ActionType.GROUP]: () => {
                callback?.(MenuType.QUICK_SETTING, value, value);
            },
            [ActionType.REPLACE_PICTURE]: () => {
                const selectedModel = this.getSelectionService()?.getSelectedModel();
                // eslint-disable-next-line no-nested-ternary
                const action = selectedModel?.type === UIModelType.MULTIPLY
                    ? ImageReplaceAction.multi
                    : selectedModel?.type === UIModelType.IMAGE
                        ? ImageReplaceAction.foreground
                        : ImageReplaceAction.background;
                this.handleReplacePic(value, action);
            },
            [ActionType.AI_PICTURE]: () => {
                this.handleAiPic(value, option);
            },
            [ActionType.RESET_PICTURE]: () => {
                const { data } = this.state;
                const values = data?.values;
                if (!values) return;
                this.handleResetPic(value);
            },
            [ActionType.CLIP]: () => {
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_FORMAT,
                    action: TDWActionType.PIC_CROP,
                });
                callback?.(MenuType.QUICK_SETTING, id, value, option);
            },
            [ActionType.DOWNLOAD_ATTACHMENT]: () => {
                this.handleDownloadMedia();
            },
            [ActionType.DELETE_ATTACHMENT]: () => {
                this.handleDeleteMedia();
            },
            [ActionType.AI_WRITE]: () => {
                this.handleAiWrite();
            },
        };
        if (typeof (handleClickMap[id]) === 'function') {
            handleClickMap[id]();
        } else if (id === ActionType.ADDON && !handleClickMap[value] && value?.indexOf(ADDON_PREFIX) === 0) {
            const tdwOption = {
                ver9: TDWVer9Type.DETAIL_PIC_TOOLBAR,
            };
            (this.getAddonManager().addonHandler as IAddonHandler).handleAddonSceneItemClick(value, tdwOption);
        } else {
            const isFontSizeChange = this.handleFontSizeChangeClick(id, callback, option);
            if (!isFontSizeChange) callback?.(MenuType.QUICK_SETTING, id, value, option);
        }
    };

    private handleFontSizeChangeClick(id, callback, option) {
        let size;
        let flag = false;
        switch (id) {
            case ActionType.FONTSIZE_UP:
                // 上报
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_FORMAT,
                    action: TDWActionType.FONT_TEXT_FONT,
                });
                size = getQuickSetFontSize(this.state.data?.items || '', ActionType.FONTSIZE_UP);
                callback(
                    MenuType.QUICK_SETTING, id,
                    { size, max: FontSizeBoundaryVal.FONT_SIZE_MAX }, option,
                );
                flag = true;
                break;
            case ActionType.FONTSIZE_DOWN:
                // 上报
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_FORMAT,
                    action: TDWActionType.FONT_TEXT_FONT,
                });
                size = getQuickSetFontSize(this.state.data?.items || '', ActionType.FONTSIZE_DOWN);
                callback(
                    MenuType.QUICK_SETTING, id,
                    { size: -size, min: FontSizeBoundaryVal.FONT_SIZE_MIN }, option,
                );
                flag = true;
                break;
        }
        return flag;
    }


    private async handleReplacePic(value, action) {
        const module = await this.getCopyPasteImageService()?.promise();
        if (!module) return;
        const { ImageEditManager } = module;
        if (value === ActionType.REPLACE_PICTURE_FROM_FILE) {
            ImageEditManager.getInstance().replaceImageFromFile(action);
        } else if (value === ActionType.REPLACE_PICTURE_FROM_CLIPBOARD) {
            ImageEditManager.getInstance().replaceImageFromClipBoard(action);
        } else if (value === ActionType.REPLACE_PICTURE_SEARCH) {
            this.getSmartReplaceImageService()?.promise()
                .then(service => service.showReplaceDrawer());
        }
    }

    private async handleAiPic(value, option) {
        const smartReplaceImageService = await this.getSmartReplaceImageService()?.promise();
        if (value === ActionType.REPLACE_PICTURE_GENERATE) {
            const selectedModel = this.getSelectionService()?.getSelectedModel();
            smartReplaceImageService?.showGenerateCard(option.domId, selectedModel);
        } else if (value === ActionType.REPLACE_PICTURE_SEARCH) {
            smartReplaceImageService?.showReplaceDrawer();
        }
    }

    private handleResetPic(value) {
        transaction(() => {
            const selectedModel = this.getSelectionService()?.getSelectedModel();
            const selectedModels = getAllChildModels(selectedModel as IElementBaseModel);
            selectedModels.forEach((model) => {
                if (model.type === UIModelType.IMAGE) {
                    (model as IPictureModel).handleResetPicture(value === ActionType.RESET_PICTURE_SIZE);
                } else if (model.type === UIModelType.SHAPE) {
                    (model as IShapeModel).getImageFillEffect()?.handleResetPicture();
                }
            });
        });
    }

    private handleDeleteMedia() {
        this.getSelectionService().currentSlide?.deleteElement();
        // 上报
        tdw({
            opername: TDWOperationType.DOC_WORD_EDITOR,
            module: TDWModuleType.LOCAL_FILES,
            action: TDWActionType.TOOLBAR_DELETE,
        });
    }

    private handleDownloadMedia() {
        const elem = this.getSelectionService().selectedElements.getCurrentModel();

        if (has(elem, 'props.attachment.objKey') && !isEmpty(elem.props.attachment.objKey)) {
            AttachmentUploader.getInstance().download(elem.props.attachment.objKey);
        }
        if (elem.isMedia?.()) {
            const objKey = elem.video?.link || elem.audio?.link;
            AttachmentUploader.getInstance().download(objKey);
        }
        // 上报
        tdw({
            opername: TDWOperationType.DOC_WORD_EDITOR,
            module: TDWModuleType.LOCAL_FILES,
            action: TDWActionType.DOWNLOAD_CLICK,
        });
    }

    /* AI写作，目前只有 Shape Element 拥有 */
    private handleAiWrite() {
        const shapeModel = this.selectedModel as IShapeModel;
        const getTextFromShape = () => shapeModel?.getTextContent?.();
        const aiFloatManager = this.getAppServices()?.editableServiceLayer?.aiFloatManager;
        aiFloatManager?.showAIModal({
            positionWithSelection: true,
        });

        // 上报点击 AI 写作入口
        tdw({
            opername: TDWOperationType.DOC_PPT_AI,
            module: TDWModuleType.AI_WRITE,
            action: TDWActionType.AI_CLK,
            ver5: TDWModuleType.PC,
            ver6: aiFloatManager?.getSourceType(),
        });
    }

    private handleDoubleClick = (id) => {
        switch (id) {
            case ActionType.FORMAT_BRUSH: {
                this.getFormatBrushManager()?.onDoubleClickButton();
                break;
            }
        }
    };

    private handleMultiItemClick = (menuType, id, value) => {
        this.handleClick(id, value, null);
    };

    private getCurFontSize = (values) => {
        if (!values) {
            const { data } = this.state;
            values = data ? data.values : null;
        }
        if (values) {
            const curFontValue = values[ActionType.FONTSIZE];
            if (curFontValue) {
                const n = curFontValue.match(/-([\d.]*)pt/);
                if (!n) return;
                const size = Number(n[1]);
                return size;
            }
        }
    };

    private handleMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    private renderDropdownItem(item, RenderComponent) {
        switch (item.dropdown.type) {
            case DropdownType.COLOR:
                RenderComponent = ToolbarItemColor;
                break;
            case DropdownType.CUSTOM:
            case DropdownType.GRID:
            case DropdownType.CROP:
            case DropdownType.EFFECT:
            case DropdownType.ADDON:
            case DropdownType.AI_PICTURE:
                RenderComponent = ToolbarItemImage;
                break;
            default:
                RenderComponent = ToolbarItemText;
                break;
        }
        return RenderComponent;
    }
}
